const navigationLinks = [
    {text: "Home", link: "/", icon: "home"},
    {text: "Projects", link: "/projects", icon: "dashboard"},
    {text: "About", link: "/about", icon: "info"},
    {text: "Contact", link: "/contact", icon: "contact_page"}
]
export { navigationLinks }